import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap'
//import OneDriveTeste from '../OneDriveTeste/OneDriveTeste';
import handleGeneratePdf from '../../../services/handlePdf.js';
import { getProdutoFinal, getReg, getRegs, insert, notifyByEmail, update, getProdCoordenadorPfId } from '../../../utils/fc/index.js'
import oikosApi from '../../../services/oikos/index.js'
import qs from 'qs'
import { notifyError, notifySuccess } from '../../../utils/notify/index.js'




const ModalFormGestaoTecnica = ( {dataContratual, tecResp, ...props} ) => {

    const [open, setOpen] = useState(false);
    const [obsTec, setObsTec] = useState('');
    const [valueConteudo, setValueConteudo] = useState(2);
    const [revAvalConteudo, setRevAvalConteudo] = useState(2);
    const [revAvalGramatica, setRevAvalGramatica] = useState(2);
    const [revAvalLayout, setRevAvalLayout] = useState(2);
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const { prod_id, proj_id } = useParams();
    const [openModalErro, setOpenModalErro] = useState(false);
    const [parecerRev, setParecerRev] = useState(props.prodStatusAlt_obs);
    const [notasRev, setNotasRev] = useState({});

    const handleClickOpen = () => {
    setOpen(true);
    };

    const handleClose = () => {
    setOpen(false);
    };

    const handleChangeObs = (event) => {
        setObsTec(event.target.value);
    };

    const getStatusFive = async () => {
        try {
            const queryString = qs.stringify({
                action: 'get',
                table: 'prodStatusAlt',
                data: {
                    prod_id: props.produto.prod_id,
                    prodStatusTp_id: 5,
                    prodStatusAlt_ativo: 1,
                },
            });

            // Make the GET request
            const res = await oikosApi.get(`/?${queryString}`);

            if (res.ok) {
                const records = res.data;

                if (records.length > 0) {
                    // Find the maximum date
                    const maxDateRecord = records.reduce((maxRecord, currentRecord) => {
                        const currentRecordDate = new Date(currentRecord.prodStatusAlt_dtCria);
                        const maxRecordDate = new Date(maxRecord.prodStatusAlt_dtCria);
                        return currentRecordDate > maxRecordDate ? currentRecord : maxRecord;
                    });

                    console.log('Record with the latest date:', maxDateRecord);
                    return maxDateRecord;
                } else {
                    console.log('No records found.');
                }
            } else {
                console.error('Error in API response:', res.problem, res.data);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    const getStatusNine = async () => {
        try {
            const queryString = qs.stringify({
                action: 'get',
                table: 'prodStatusAlt',
                data: {
                    prod_id: props.produto.prod_id,
                    prodStatusTp_id: 9,
                    prodStatusAlt_ativo: 1,
                },
            });

            // Make the GET request
            const res = await oikosApi.get(`/?${queryString}`);

            if (res.ok) {
                const records = res.data;

                if (records.length > 0) {
                    // Find the maximum date
                    const maxDateRecord = records.reduce((maxRecord, currentRecord) => {
                        const currentRecordDate = new Date(currentRecord.prodStatusAlt_dtCria);
                        const maxRecordDate = new Date(maxRecord.prodStatusAlt_dtCria);
                        return currentRecordDate > maxRecordDate ? currentRecord : maxRecord;
                    });

                    console.log('Record with the latest date:', maxDateRecord);
                    return maxDateRecord;
                } else {
                    console.log('No records found.');
                }
            } else {
                console.error('Error in API response:', res.problem, res.data);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    const aprovaGestao = async () => {
        setIsStatusLoading(true)
        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 5, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
        const lastStatusFive = await getStatusFive();
        console.log(lastStatusFive)
        await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusFive.prodStatusAlt_id, prodGestaoAval_avalEP: `${valueConteudo}`, prodGestaoAval_aprovEP: 0, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
        await notifyByEmail(props.produto.prod_id, {obs: obsTec});
        notifySuccess('Produto aprovado!');
        handleClose();
        setIsStatusLoading(false)
        //substituir pela re-renderização
        props.setCount(prevState => prevState + 1);
        /*
        const doc = await getProdutoFinal(props.produto.prod_drive, "admin@ecossis.com.br", '.docx');
        if (!doc) {
          const fileProdFinal = await getProdutoFinal(props.produto.prod_drive, "admin@ecossis.com.br", props.produto.prod_formato);
          if (!fileProdFinal) {
            setIsStatusLoading(false);
            setOpenModalErro(!openModalErro);
            handleClose();
          } else {
            await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 5, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
            const lastStatusFive = await getStatusFive();
            console.log(lastStatusFive)
            await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusFive.prodStatusAlt_id, prodGestaoAval_avalEP: `{Conteudo: ${valueConteudo}, Gramatica: ${valueGramatica}, Layout: ${valueLayout}}`, prodGestaoAval_aprovEP: 0, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
            await notifyByEmail(props.produto.prod_id, {obs: obsTec});
            notifySuccess('Produto aprovado!');
            handleClose();
            setIsStatusLoading(false)
            props.setCount(prevState => prevState + 1);
          };
        } else {
          await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 5, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
          const lastStatusFive = await getStatusFive();
          console.log(lastStatusFive)
          await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusFive.prodStatusAlt_id, prodGestaoAval_avalEP: `{Conteudo: ${valueConteudo}, Gramatica: ${valueGramatica}, Layout: ${valueLayout}}`, prodGestaoAval_aprovEP: 0, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
          await notifyByEmail(props.produto.prod_id, {obs: obsTec});
          notifySuccess('Produto aprovado!');
          handleClose();
          setIsStatusLoading(false)
          props.setCount(prevState => prevState + 1);
        };
        */
      };

    const reprovaGestao = async () => {
        setIsStatusLoading(true)
        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 9, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
        const lastStatusNine = await getStatusNine();
        await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusNine.prodStatusAlt_id, prodGestaoAval_avalEP: `${valueConteudo}`, prodGestaoAval_aprovEP: 1, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
        await notifyByEmail(props.produto.prod_id, {obs: obsTec});
        handleClose();
        setIsStatusLoading(false)
        props.setCount(prevState => prevState + 1);
        /*
        const doc = await getProdutoFinal(props.produto.prod_drive, "admin@ecossis.com.br", '.docx');
        if (!doc) {
          const fileProdFinal = await getProdutoFinal(props.produto.prod_drive, "admin@ecossis.com.br", props.produto.prod_formato);
          if (!fileProdFinal) {
            setIsStatusLoading(false);
            setOpenModalErro(!openModalErro);
            handleClose();
          } else {
            await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 9, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
            const lastStatusNine = await getStatusNine();
            await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusNine.prodStatusAlt_id, prodGestaoAval_avalEP: `{Conteudo: ${valueConteudo}, Gramatica: ${valueGramatica}, Layout: ${valueLayout}}`, prodGestaoAval_aprovEP: 1, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
            await notifyByEmail(props.produto.prod_id, {obs: obsTec});
            handleClose();
            setIsStatusLoading(false)
            props.setCount(prevState => prevState + 1);
          }
        } else {
          await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 9, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
          const lastStatusNine = await getStatusNine();
          await insert('prodGestaoAval', {prodStatusAlt_id: lastStatusNine.prodStatusAlt_id, prodGestaoAval_avalEP: `{Conteudo: ${valueConteudo}, Gramatica: ${valueGramatica}, Layout: ${valueLayout}}`, prodGestaoAval_aprovEP: 1, prodGestaoAval_coment: obsTec, prodGestaoAval_usuarioCria: props.userOikosId, prodGestaoAval_usuarioMod: props.userOikosId});
          await notifyByEmail(props.produto.prod_id, {obs: obsTec});
          handleClose();
          setIsStatusLoading(false)
          props.setCount(prevState => prevState + 1);
        }
        */
    };

    useEffect(()=>{
      const fetchNotas = async () => {
        try {
          const arrayOfObjects = JSON.parse(props.prodStatusAlt_obs);
          setParecerRev(arrayOfObjects);

          if (props.actual === 4) {
            const statusAlt = await getRegs('prodStatusAlt', {prod_id: props.produto.prod_id});  // Await the result here
            const statusAltId = statusAlt[(statusAlt.length - 1)].prodStatusAlt_id;
            const avalRev = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'prodComplianceAval',
              data: {prodStatusAlt_id: statusAltId},
              fields: {},
            })}`)
            setRevAvalConteudo(avalRev.data[0].prodComplianceAval_conteudo);
            setRevAvalLayout(avalRev.data[0].prodComplianceAval_layout);
            setRevAvalGramatica(avalRev.data[0].prodComplianceAval_gramat);

          }
        } catch (error) {
          console.error('Error:', error); // Catch any errors
        }
      };

      fetchNotas();
    }, [])


    return (
        <>
            <Button variant="" onClick={handleClickOpen}>
                Aprovação da gestão
            </Button>
            <Dialog
                fullWidth
                maxWidth= 'sm'
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: async (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        console.log(formJson);
                        handleClose();
                    },
                    }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle>Aprovação da gestão</DialogTitle>
            <DialogContent>
            <div className="d-flex">
                <div className='d-flex flex-column flex-fill'>
                    <div className="d-flex justify-content-between mb-3">
                        <div>
                            <span>Técnico Responsável</span>
                            <h6>{tecResp}</h6>
                        </div>
                        <div>
                          <span>Data contratual</span>
                          {(moment(dataContratual, 'DD/MM/YYYY').toDate().getTime() > Date.now()) ? <h6 className='text-success'>{dataContratual}</h6> : <h6 className='text-danger'>{dataContratual}</h6>}
                        </div>
                        <div>
                          <span>Data Entrega</span>
                          {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                            moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-success'>{props.dataEntregueAGestao}</h6>}
                          {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                            moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-danger'>{props.dataEntregueAGestao}</h6>}
                          {props.dataEntregueAoEp &&
                            moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-success'>{props.dataEntregueAoEp}</h6>}
                          {props.dataEntregueAoEp &&
                            moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                            && <h6 className='text-danger'>{props.dataEntregueAoEp}</h6>}
                        </div>
                    </div>
                    <div className="d-flex justify-content-between mb-3">
                            {Array.isArray(parecerRev) ? (
                              <>
                              <div>
                                  <span>Observações da revisão:</span><br/>
                                  {parecerRev.map((item, index) => (
                                    <div key={index}>
                                      <div className='mb-2'>
                                        <span style={{fontWeight: '600'}}>Item {item.obsNum}</span><br/>
                                        <span>Observação: {item.observacao}</span><br/>
                                        <span>Página: {item.pagina}</span><br/>
                                      </div>
                                      <hr style={{ borderColor: 'grey', borderWidth: '1px' }} />
                                    </div>
                                  ))}
                              </div>
                              <div>
                                <span className='mb-2'>Avaliação da Revisão:</span><br/>
                                <span>Conteúdo: </span><span style={{fontWeight: '600'}}>{revAvalConteudo}</span><br/>
                                <span>Layout: </span><span style={{fontWeight: '600'}}>{revAvalLayout}</span><br/>
                                <span>Gramática: </span><span style={{fontWeight: '600'}}>{revAvalGramatica}</span><br/>
                              </div>
                              </>
                            ) : (
                              <div className="d-flex justify-content-between mb-3">
                                <div>
                                  <span>Observações do(a) técnico(a):</span>
                                  <h6>{props.prodStatusAlt_obs}</h6>
                                </div>
                              </div>
                            )}
                        </div>
                    <span>Observação técnica:</span>
                    <TextareaAutosize
                        placeholder='Observações'
                        margin="dense"
                        id="input_obs"
                        name="input_obs"
                        variant="standard"
                        className='mb-3 p-1'
                        onChange={handleChangeObs}
                    />

                    <div className="d-flex justify-content-between mb-3">
                        <div>
                            <Typography className='mt-4' component="legend">Avaliação para o produto:</Typography>
                            <Rating
                                name="avaliacao_conteudo"
                                value={valueConteudo}
                                onChange={(event, newValue) => {
                                setValueConteudo(newValue);
                                }}
                            />
                        </div>
                    </div>
                    <a target='_blank' href={`${props.produto.prod_drive}`}>Link para a pasta do produto</a>
                </div>
            </div>
                </DialogContent>
            <DialogActions>
                {isStatusLoading &&(
                    <Button
                        autoFocus
                        margin="dense"
                        id="entregaRevInterna"
                        name="entrega_rev_interna"
                        label="Entrega a Revisao Interna"
                        type="submit"
                        variant="outlined"
                        disabled
                        endIcon={<Spinner/>}
                    >Aguarde</Button>
                )}
                {!isStatusLoading && (
                    <div className="d-flex justify-content-start mb-3">
                        <Button
                            autoFocus
                            className='text-success'
                            margin="dense"
                            id="aprova"
                            name="aprova_produto"
                            label="Aprovar o produto"
                            type="submit"
                            variant="standard"
                            onClick={aprovaGestao}
                        >Aprovar</Button>
                        <Button
                            autoFocus
                            className='text-danger'
                            margin="dense"
                            id="reprova"
                            name="reprova_produto"
                            label="Reprovar o produto"
                            type="submit"
                            variant="standard"
                            onClick={reprovaGestao}
                        >Reprovar</Button>
                    </div>
                )}
                <Button onClick={handleClose}>Cancelar</Button>
            </DialogActions>
            </Dialog>
        </>
    )
}

ModalFormGestaoTecnica.propTypes = {
    dataContratual: PropTypes.string,
    tecResp: PropTypes.string,
};

export default ModalFormGestaoTecnica;
